import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogClose,
  Dialog,
} from "@/components/ui/dialog"

import { Button } from "../ui/button"

interface Props {
  open: boolean
  onClose: () => void
  onDismiss: () => void
}

export function UncategorizedPendingDialog({
  open,
  onClose,
  onDismiss,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Uncategorized Documents</DialogTitle>
          <DialogDescription>
            Please categorize your uploaded documents before leaving this page.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onDismiss}>
            Skip for now
          </Button>
          <DialogClose asChild>
            <Button>Close</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
